/**
 * Patient API-to-Client Adapter
 * 
 * Transforms PatientDto from API into simplified ClientPatient
 */

import { PatientDto } from "../../../../../api-client";
import { ClientPatient } from "../types";

/**
 * Transform API PatientDto to simplified ClientPatient
 */
export const adaptPatientFromApi = (patient: PatientDto): ClientPatient => {
  const firstName = patient.firstName || '';
  const lastName = patient.lastName || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const displayName = firstName ? `${lastName}, ${firstName}` : lastName;
  
  return {
    id: patient.id!,
    firstName,
    lastName,
    salutation: patient.salutation || '',
    fullName,
    displayName: displayName // Remove truncation
  };
};

const truncateName = (name: string, maxLength: number) => {
  if (name.length <= maxLength) return name;
  return name.slice(0, maxLength) + '...';
};